document.querySelectorAll('.image-columns_swiper').forEach(el => {
  new Swiper(el, {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: el.querySelector('.image-columns_pagination'),
      clickable: true,
    },
    navigation: {
      prevEl: el.querySelector('.image-columns_prev'),
      nextEl: el.querySelector('.image-columns_next'),
    },
    breakpoints: {
      992: {
        enabled: false,
        slidesPerView: 3,
        spaceBetween: 24,
      }
    }
  });
});